import React from "react";
import { HiOutlineUserGroup } from "react-icons/hi";
import { FiBox } from "react-icons/fi";
import { AiOutlineLineChart } from "react-icons/ai";
import { GrTrophy } from "react-icons/gr";

const Dashboard = ({ data, earning })=> {
  return (
    <>
      <section className="py-4">
        <div className="grid grid-cols-1 gap-2 md:grid-cols-2 md:gap-6 lg:grid-cols-3 lg:gap-2 xl:grid-cols-4 xl:gap-6 2xl:grid-cols-4 2xl:gap-6">
          <div className="bg-white border rounded-lg p-5 space-y-4 border-stroke py-6 px-7.5 shadow-default">
            <div className="flex flex-row items-center justify-between">
              <div className="text-start">
                <h2 className="font-bold uppercase text-gray-600">
                  Total Contests
                </h2>
              </div>
              <div className=" pr-4">
                <svg
                  className="bg-blue-100 w-16 h-16 text-[#124699] rounded-full px-1 py-3 text-xl"
                  viewBox="0 0 22 22"
                >
                  <GrTrophy />
                </svg>
              </div>
            </div>
            <div className="text-start">
              <p className="font-semibold text-2xl">{data?.contests || 0} </p>
            </div>
          </div>
          <div className="bg-white border rounded-lg p-5 space-y-4 border-stroke py-6 px-7.5 shadow-default">
            <div className="flex flex-row items-center justify-between">
              <div className=" text-start">
                <h2 className="font-bold uppercase text-gray-600">
                  Total questions
                </h2>
              </div>
              <div className="pr-4">
                <svg
                  className="bg-yellow-200 w-16 h-16 text-yellow-500 rounded-full px-1 py-3 text-xl"
                  viewBox="0 0 22 22"
                >
                  <FiBox />
                </svg>
              </div>
            </div>
            <div className="text-start">
              <p className="font-semibold text-2xl">{data?.questions || 0}</p>
            </div>
          </div>
          <div className="bg-white border rounded-lg p-5 space-y-4 border-stroke py-6 px-7.5 shadow-default">
            <div className="flex flex-row items-center justify-between">
              <div className=" text-start">
                <h2 className="font-bold uppercase text-gray-600">
                  Total Students
                </h2>
              </div>
              <div className=" pr-4">
                <svg
                  className="bg-purple-200 w-16 h-16 text-purple-500 rounded-full px-1 py-3 text-xl"
                  viewBox="0 0 22 22"
                >
                  <HiOutlineUserGroup />
                </svg>
              </div>
            </div>
            <div className="text-start">
              <p className="font-semibold text-2xl">{data?.users ||0}</p>
            </div>
          </div>
          <div className="bg-white border rounded-lg p-5 space-y-4 border-stroke py-6 px-7.5 shadow-default">
            <div className="flex flex-row items-center justify-between">
              <div className=" text-start">
                <h2 className="font-bold uppercase text-gray-600">
                  Total Earning
                </h2>
              </div>
              <div className=" pr-4">
                <svg
                  className="bg-green-200 w-16 h-16 text-green-500 rounded-full px-1 py-3 text-xl"
                  viewBox="0 0 22 22"
                >
                  <AiOutlineLineChart />
                </svg>
              </div>
            </div>
            <div className="text-start">
              <p className="font-semibold text-2xl">
                {earning?.overallTotalFees || 0}
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
export default Dashboard;
